import vars from "./vars"

const regist_sw = () => {

  var applicationServerPublicKey;
  if (location.host === vars.the_host) {
    applicationServerPublicKey = vars.pwa_keys.production
  } else{
    applicationServerPublicKey = vars.pwa_keys.develop
  }

  // ServiceWorkerの登録
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    console.log('Service Worker and Push is supported');

    navigator.serviceWorker.register(vars.pwa_js)
      .then(function (swReg) {
        console.log('Service Worker is registered', swReg);
        subscribeUser(swReg);
      })
      .catch(function (error) {
        console.error('Service Worker Error', error);
      });
  } else {
    console.warn('Push messaging is not supported');
    // pushButton.textContent = 'Push Not Supported';
  }

  function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  function subscribeUser(swRegistration) {
    const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);

    //TODO
    swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
      .then(function (subscription) {
        console.log('User is subscribed:', subscription);
        updateSubscriptionOnServer(subscription);

      })
      .catch(function (err) {
        console.log('Failed to subscribe the user: ', err);
      });
  }


  function updateSubscriptionOnServer(subscription) {

    var key = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh')))).replace(/\+/g, '-').replace(/\//g, '_');
    var auth = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth')))).replace(/\+/g, '-').replace(/\//g, '_');

    // Send subscription to application server
    $.ajax({
      method:"POST",
      url: vars.api.web_register,
      data: {
        endpoint: subscription.endpoint,
        user_public_key: key,
        auth: auth,
      }
    }).done(function(data){
      console.log('COMPLETE! :' + data);
    }).fail(function(e, data){
      console.log('Failed. HttpStatus: ' + e);
    });

  }
}

$(function(){
  try {
    regist_sw();
  } catch (error) {
    console.log(error)
  }
});




// WEBPACK FOOTER //
// ./_src/js/pwa/regist-service-worker.js